import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;
export class AheadAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.AHEAD, t.to('常に直進', 'ahead'));
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    ShapeSettings.setTitleField(block, this.title);

    const speed = new Blockly.FieldTextInput('1');
    block
      .appendDummyInput()
      .appendField(`${t.to('スピード', 'speed')}:`)
      .appendField(speed, 'speed');

    const pitchSwitch = new Blockly.FieldDropdown([
      ['OFF', 'false'],
      ['ON', 'true'],
    ]);
    block
      .appendDummyInput()
      .appendField(t.to('上下移動', 'pitch'))
      .appendField(pitchSwitch, 'pitchSwitch');

    const stop_at_touch = new Blockly.FieldDropdown([
      [t.to('なにもしない', 'stopattouch_false'), 'false'],
      [t.to('止まる', 'stopattouch_true'), 'true'],
    ]);
    block
      .appendDummyInput()
      .appendField(t.to('タッチ時', 'stopattouch'))
      .appendField(stop_at_touch, 'stopattouch');

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const speed = CodeSetting.getFieldValue(block, 'speed');
    const stop_at_touch = CodeSetting.getFieldValue(block, 'stopattouch');
    const pitchSwitch = CodeSetting.getFieldValue(block, 'pitchSwitch');

    const str = CodeSetting.buildAttribute(
      [[this.name_for_code, `speed:${speed};pitch:${pitchSwitch};stopattouch:${stop_at_touch}`]],
      attribute
    );
    return [str];
  }
}
